<template>
  <v-dialog
    v-model="dialog"
    persistent
    hide-overlay
    max-width="800"
  >
    <v-card>
      <v-toolbar
        color="amber"
      >
        <v-toolbar-title>
          Support Ticket
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="onCloseClick()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">Equipment Information</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 2" step="2">Problem Description</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3">Attempted Resolution</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card flat class="mb-12" height="400px">
              <v-flex class="d-inline-flex" style="margin: 0 auto; padding-left: 45px; padding-bottom: 10px; width: 100%;">
                <div style="width: 50%;" md4><b>Serial Number:&nbsp;&nbsp;</b>{{aligner.serialNumber}}</div>
                <div style="width: 50%;" md4 v-if="aligner.version"><b>Software Version:&nbsp;&nbsp;</b>{{aligner.version.semantic}}</div>
                <div style=""
                <!--<div style="width: 33%;" md4 v-if="aligner.specs"><b>Specs Version:&nbsp;&nbsp;</b>{{aligner.specs ? aligner.specs.name : 'unkown'}}</div>-->
              </v-flex>
              <v-container>
                <v-row>
                  <v-col>
                    <v-select
                      label="Currently connected to dashboard?"
                      outlined
                      :items="yesNo"
                      :value="getOnline()"
                      @input="onConnectedInput"
                    >
                    </v-select>
                  </v-col>
                  <v-col>
                    <v-select
                      label="Is there a sales or service tech on site?"
                      outlined
                      :items="yesNo"
                      v-model="ticket.techOnSite"
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="ticket.originatorName"
                      label="Caller's name?"
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="ticket.originatorEmail"
                      label="Caller's contact info?"
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-select
                      v-model="ticket.disposition"
                      :items="unitSelection"
                      label="Demo, New Install, Transfer or Owned?"
                      outlined
                    >
                    </v-select>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="ticket.inService"
                      label="How long has the customer had this unit?"
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
            <v-spacer></v-spacer>
            <div>
              <span style="float: right;">
                <v-btn color="primary" class="mr-5" @click="step = 2">Next</v-btn>
                <v-btn color="grey lighten-1" @click="onCloseClick()">Cancel</v-btn>
              </span>
            </div>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-card flat class="mb-12" height="400px">
              <v-container>
                <v-textarea
                  v-model="ticket.description"
                  outlined
                  rows="2"
                  label="What are the problems occurring with this unit?"
                >
                </v-textarea>
                <v-text-field
                  v-model="ticket.circumstance"
                  outlined
                  label="What was the customer doing when the problem occurred?"
                >
                </v-text-field>
                <v-text-field
                  v-model="ticket.issueStartedOn"
                  outlined
                  label="When did the issue start?"
                >
                </v-text-field>
                <v-text-field
                  v-model="ticket.environment"
                  outlined
                  label="What environmental factors might be involved?"
                >
                </v-text-field>
                <v-row>
                  <v-col>
                    <v-select
                      label="Is this issue currently happening?"
                      outlined
                      :items="yesNo"
                      v-model="ticket.exhibitingNow"
                    >
                    </v-select>
                  </v-col>
                  <v-col>
                    <v-select
                      label="Can the issue be reproduced?"
                      outlined
                      :items="yesNo"
                      v-model="ticket.reproducible"
                    >
                    </v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
            <v-spacer></v-spacer>
            <div>
              <v-btn color="primary" @click="step = 1">Previous</v-btn>
              <span style="float: right;">
                <v-btn color="primary" class="mr-5" @click="step = 3">Next</v-btn>
                <v-btn color="grey lighten-1" @click="onCloseClick()">Cancel</v-btn>
              </span>
          </v-stepper-content>
          <v-stepper-content step="3">
            <v-card flat class="mb-12" height="400px">
              <v-container>
                <v-textarea
                  v-model="ticket.attemptedResolution"
                  outlined
                  rows="3"
                  label="What steps have been taken to resolve the issue?"
                >
                </v-textarea>
                <v-textarea
                  v-model="ticket.other"
                  outlined
                  rows="2"
                  label="What other information could help resolve this issue?"
                >
                </v-textarea>
                <v-textarea
                  v-model="ticket.componentsReplaced"
                  outlined
                  rows="2"
                  label="What components (if any) were recently replaced?"
                >
                </v-textarea>
                <v-checkbox
                  v-model="ticket.escalated"
                  label="Escalate to engineering (generate emails)"
                >
                </v-checkbox>
              </v-container>
            </v-card>

            <v-spacer></v-spacer>

            <div>
              <v-btn color="primary" @click="step = 2">Previous</v-btn>
              <span style="float: right;">
                <v-btn color="amber" class="mr-5" @click="submit">Save</v-btn>
                <v-btn color="grey lighten-1" @click="onCloseClick()">Cancel</v-btn>
              </span>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>

<script>
import decodeSerialNumber from '../../decodeSerialNumber';

export default {
  props: {
    dialog: Boolean,
    aligner: Object,
  },

  data() {
    return {
      step: 1,
      yesNo: ['Yes', 'No'],
      unitSelection: ['Demo', 'New Install', 'New Transfer', 'Owned Aligner'],
      ticket: {
        online: false,
        originatorName: '',
        originatorEmail: '',
        techOnSite: '',
        exhibitingNow: '',
        reproducible: '',
        disposition: '',
        inService: '',
        componentsReplaced: '',
        description: '',
        issueStartedOn: '',
        circumstance: '',
        attemptedResolution: '',
        environment: '',
        other: '',
        escalated: true,
      },
    };
  },

  methods: {
    onCloseClick() {
      this.step = 1;

      this.ticket = {
        online: false,
        originatorName: '',
        originatorEmail: '',
        techOnSite: '',
        exhibitingNow: '',
        reproducible: '',
        disposition: '',
        inService: '',
        componentsReplaced: '',
        description: '',
        issueStartedOn: '',
        circumstance: '',
        attemptedResolution: '',
        environment: '',
        other: '',
        escalated: true,
      };

      this.$emit('close', 0);
    },

    getOnline() {
      const online = (this.aligner.connected === true ? 'Yes' : 'No');
      return online;
    },

    onConnectedInput(value) {
      this.ticket.online = value === 'Yes';
    },

    submit() {
      const data = {
        issuerUsername: this.$store.state.auth.token.user.username,
        issuerEmail: this.$store.state.auth.token.user.email,
        originatorName: this.ticket.originatorName,
        originatorEmail: this.ticket.originatorEmail,
        techOnSite: this.ticket.techOnSite === 'Yes',
        exhibitingNow: this.ticket.exhibitingNow === 'Yes',
        reproducible: this.ticket.reproducible === 'Yes',
        disposition: this.ticket.disposition,
        inService: this.ticket.inService,
        componentsReplaced: this.ticket.componentsReplaced,
        description: this.ticket.description,
        circumstance: this.ticket.circumstance,
        attemptedResolution: this.ticket.attemptedResolution,
        environment: this.ticket.environment,
        other: this.ticket.other,
        issueStartedOn: this.ticket.issueStartedOn,
        serialNumber: this.aligner.serialNumber,
        version: this.aligner.version.semantic,
        specs: this.aligner.specs ? this.aligner.specs.name : 'unknown',
        connected: this.ticket.online,
        escalated: this.ticket.escalated,
        family: this.aligner.family,
        model: decodeSerialNumber(this.aligner.serialNumber),
      };

      const options = {
        method: 'POST',
        url: '/create/ticket/v1',
        data,
      };

      this.axios(options)
        .then((res) => {
          this.ticket = {
            online: false,
            originatorName: '',
            originatorEmail: '',
            techOnSite: '',
            exhibitingNow: '',
            reproducible: '',
            disposition: '',
            inService: '',
            componentsReplaced: '',
            description: '',
            issueStartedOn: '',
            circumstance: '',
            attemptedResolution: '',
            environment: '',
            other: '',
            escalated: true,
          };

          this.step = 1;

          this.$emit('close', 1);
        })
        .catch((err) => {
          console.error('!!! failed response !!!');
        });
    },
  },
};
</script>

<style scoped>
</style>
